var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExploreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 20.5C16.5228 20.5 21 16.0228 21 10.5C21 4.97715 16.5228 0.5 11 0.5C5.47715 0.5 1 4.97715 1 10.5C1 16.0228 5.47715 20.5 11 20.5Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7221 6.76596C14.2107 6.60312 14.4549 6.52169 14.6174 6.57962C14.7587 6.63003 14.87 6.74127 14.9204 6.88263C14.9783 7.04507 14.8969 7.28935 14.734 7.77789L13.2465 12.2405C13.2001 12.3797 13.1769 12.4492 13.1374 12.507C13.1024 12.5582 13.0582 12.6024 13.007 12.6374C12.9492 12.6769 12.8797 12.7001 12.7405 12.7465L8.27789 14.234C7.78935 14.3969 7.54507 14.4783 7.38263 14.4204C7.24127 14.37 7.13003 14.2587 7.07962 14.1174C7.02169 13.9549 7.10312 13.7107 7.26596 13.2221L8.75351 8.75947C8.79989 8.62033 8.82308 8.55076 8.8626 8.49299C8.8976 8.44182 8.94182 8.3976 8.99299 8.3626C9.05076 8.32308 9.12033 8.29989 9.25947 8.25351L13.7221 6.76596Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExploreIcon);
export default __webpack_public_path__ + "static/media/ExploreIcon.15d5cd6838c0127d2c70a921ef2f1ca7.svg";
export { ForwardRef as ReactComponent };